module.exports = __webpack_public_path__ + "img/tutorial_guideChat_03.94ffa17a.jpg";